<template>
    <div class="panel-content">
        <h2>Behandeling van prostaatkanker</h2>
        <p>Wanneer prostaatkanker eenmaal is uitgezaaid, is genezing momenteel niet meer mogelijk. Er is daarom dringend behoefte aan betere diagnostiek en effectieve nieuwe behandelingen. In het Radboudumc worden nieuwe behandelingen op basis van radionuclidentherapie in klinisch studieverband getest. Het gaat hierbij om het koppelen van radioactief Lu-177 of Ac-225 aan PSMA, waardoor we uiteindelijk door middel van inwendige bestraling specifiek de kankercellen kunnen beschadigen. Bij een aantal patiënten zijn uitzaaiingen geheel verdwenen na behandeling met Ac-225-PSMA. Helaas is Ac-225 maar beperkt beschikbaar en zijn er bijwerkingen na behandeling met Ac-225-PSMA, zoals een droge mond. Daarom zijn we in samenwerking met NRG aan het onderzoeken of radiotherapie op basis van Pb-212 gekoppeld aan PSMA een geschikte alternatieve behandelmethode is. Doordat er bij het verval van Pb-212 minder energie vrijkomt, dan bij verval van Ac-225, is de kans op bijwerkingen minder groot. Ook de kortere halfwaardetijd van Pb-212 (11 uur) ten opzichte van Ac-225 (10 dagen), kan mogelijk leiden tot minder schade aan gezonde organen.</p>

        <p>Wilt u meer weten over tracers op basis van PSMA? Kijk dan eens op de volgende webpagina:</p>
        <a @click="trackLink" class="button" href="https://psmaforum.nl/" target="_blank">Meer informatie</a>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {
        methods: {
            trackLink()
            {
                window.dataLayer.push({ 'event': 'clickout', 'url': 'https://psmaforum.nl/' });
            }
        }
    };
</script>
